// Spain
export const locale = {
	lang: 'es',
	data: {
		TRANSLATOR: {
			SELECT: 'Elige tu idioma',
		},
		MENU: {
			NEW: 'nuevo',
			ACTIONS: 'Comportamiento',
			CREATE_POST: 'Crear nueva publicación',
			PAGES: 'Pages',
			FEATURES: 'Caracteristicas',
			APPS: 'Aplicaciones',
			DASHBOARD: 'Tablero'
		},
		AUTH: {
			GENERAL: {
				OR: 'O',
				SUBMIT_BUTTON: 'Enviar',
				NO_ACCOUNT: 'No tienes una cuenta?',
				SIGNUP_BUTTON: 'Regístrate',
				FORGOT_BUTTON: 'Se te olvidó tu contraseña',
				BACK_BUTTON: 'Espalda',
				PRIVACY: 'Intimidad',
				LEGAL: 'Legal',
				CONTACT: 'Contacto',
			},
			LOGIN: {
				TITLE: 'Crear una cuenta',
				BUTTON: 'Registrarse',
			},
			FORGOT: {
				TITLE: 'Contraseña olvidada?',
				DESC: 'Ingrese su correo electrónico para restablecer su contraseña',
				SUCCESS: 'Your account has been successfully reset.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				EMAIL: 'Email',
				FULLNAME: 'Fullname',
				PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				USERNAME: 'Usuario'
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		INVOICES: {
			VALIDATION: {
				REQUIRED_FIELD: 'Campo requerido',
				INVALID_DATE_RANGE: 'Rango de fechas inválido.',
				NOT_ALLOWED_DATE_RANGE: 'El rango máximo es de 30 días.',
				NOT_RECORDS_FOUND: 'No se encontraron registros.',
				PO_DIALOG_INVALID: 'Faltan datos de la orden de compra o no son válidos.',
			}
		},
		INQUIRIES: {
			                   SALE_ORDER_SEARCH: {
               NAME_COMPONENT: 'Búsqueda de Órdenes de Venta',
               ORDERS_PLACEHOLDER: 'Ingrese números de orden separados por comas',
               UPLOAD_XML_TITLE: 'Subir Archivo XML',
               ORDER_NUMBER: 'Número de Orden',
               CUSTOMER_NUMBER: 'Número de Cliente',
               CUSTOMER_NAME: 'Nombre del Cliente',
               SELECT_XML_FILE: 'Seleccionar Archivo XML',
               CHOOSE_FILE: 'Elegir Archivo',
               UPLOAD_FILE: 'Subir Archivo',
               INVALID_XML_FILE: 'Por favor seleccione un archivo XML válido',
               PLEASE_SELECT_FILE: 'Por favor seleccione un archivo para subir',
               UPLOAD_SUCCESS: 'Archivo subido exitosamente',
               UPLOAD_ERROR: 'Error al subir el archivo . Por favor intente de nuevo.',
               UPLOAD_TXT_TITLE: 'Subir Archivo TXT',
               SELECT_TXT_FILE: 'Seleccionar Archivo TXT',
               INVALID_TXT_FILE: 'Por favor seleccione un archivo TXT válido',
               UPLOAD_PO_CONFIRMATION_TITLE: 'Subir XML de Confirmación de PO',
               SELECT_PO_CONFIRMATION_XML_FILE: 'Seleccionar Archivo XML de Confirmación de PO',
               UPLOAD_ASN_TITLE: 'Subir XML de ASN',
               SELECT_ASN_XML_FILE: 'Seleccionar Archivo XML de ASN',
               UPLOAD_INVOICE_TITLE: 'Subir XML de Factura',
               SELECT_INVOICE_XML_FILE: 'Seleccionar Archivo XML de Factura'
           },
        EDI_PO_SEARCH: {
            NAME_COMPONENT: 'Búsqueda de Órdenes de Compra EDI',
            UPLOAD_XML_TITLE: 'Subir Archivo XML',
            ORDER_NUMBER: 'Número de PO',
            CUSTOMER_NUMBER: 'Número de Cliente',
            CUSTOMER_NAME: 'Nombre del Cliente',
            SELECT_XML_FILE: 'Seleccionar Archivo XML',
            CHOOSE_FILE: 'Elegir Archivo',
            UPLOAD_FILE: 'Subir Archivo',
            INVALID_XML_FILE: 'Por favor seleccione un archivo XML válido',
            PLEASE_SELECT_FILE: 'Por favor seleccione un archivo para subir',
            UPLOAD_SUCCESS: 'Archivo XML subido exitosamente',
            UPLOAD_ERROR: 'Error al subir el archivo XML. Por favor intente de nuevo.',
            UPLOAD_TXT_TITLE: 'Subir Archivo TXT',
            SELECT_TXT_FILE: 'Seleccionar Archivo TXT',
            INVALID_TXT_FILE: 'Por favor seleccione un archivo TXT válido'
        },
        SALES_INVENTORY_DIST_REPORT: {
            NAME_COMPONENT: 'Informe de ventas e inventario por distribución',
            TIME_FILTER_LABEL: 'Período del informe',
            TIME_FILTER_ARIA: 'Elija si filtra por semana Ross o por rango de fechas',
            TIME_FILTER_WEEK: 'Semana Ross (año + semana)',
            TIME_FILTER_DATE_RANGE: 'Rango de fechas',
            PART_CODE: 'Código de parte',
            PART_CODE_HINT_SELECT_CLASS: 'Seleccione al menos una clase de producto para cargar los códigos de parte.',
            YEAR: 'Año',
            WEEK: 'Semana',
            WAREHOUSE: 'Almacén',
            PRODUCT_CLASS: 'Clase de producto',
            PRODUCT_GROUP: 'Grupo de producto',
            SALESPERSON: 'Vendedor',
            CUSTOMERS: 'Clientes',
            YEAR_RANGE: 'Indique un número entre 2019 y {{maxYear}}',
            WEEK_RANGE: 'Indique un número entre 1 y 53',
            SUBMIT: 'Consultar',
            GENERATING: 'Generando informe…',
            DATE_FROM: 'Desde',
            DATE_TO: 'Hasta',
            DATE_TYPE_ORDER: 'Fecha de pedido',
            DATE_TYPE_SHIP: 'Fecha de envío',
            DATE_TYPE_DELIVERY: 'Fecha de entrega',
            TOTALS_TOP_LABEL: 'Totales (cabecera)',
            TOTAL_MANIFEST: 'Manifiesto',
            TOTAL_CARRY_OVER: 'Carry over',
            TOTAL_SOLD: 'Vendido',
            TOTAL_NET_AVAILABLE: 'Disponible neto',
            LOT_NUMBER: 'Lote',
            COLUMN_LOT_NUMBER: 'NÚMERO DE LOTE',
            COLUMN_SALESPERSON: 'VENDEDOR',
            PHYSICAL_QTY: 'Cantidad física',
            CARRY_OVER_QTY: 'Carry over',
            ALLOCATED_QTY: 'Asignado',
            NET_AVAILABLE_QTY: 'Disponible neto',
            LOT_ROWS_CAPTION: 'Detalle por lote y código de parte',
            DATE_TYPE_LABEL: 'Tipo de fecha del rango',
            EXPORT_EXCEL: 'Exportar a Excel',
            EXCEL_ROW_MANIFEST: 'Manifiesto',
            EXCEL_ROW_CARRY_OVER: 'Carry Over',
            EXCEL_ROW_TOTAL_SOLD: 'Total vendido',
            EXCEL_ROW_TOTAL_AVAILABLE: 'Total disponible',
            EXCEL_COL_CUSTOMER: 'Cliente',
            EXCEL_COL_ORDER_NUMBER: 'Número de pedido',
            EXCEL_COL_SALESPERSON: 'Vendedor',
            EXCEL_COL_LOAD_DATE: 'Fecha de carga',
            EXCEL_WEEK_OF_YEAR: 'SEMANA {{week}} DE {{year}}',
            EXCEL_SOURCE: 'Fuente',
            EXCEL_NOTES_CAPTION: 'Notas',
            EXCEL_PALLETS: 'Pallets',
            EXCEL_LOADS: 'Cargas',
            EXCEL_NEW_VESSEL: 'Nuevo buque',
            EXCEL_TOTAL_LABEL: 'TOTAL',
            EXCEL_QTY_PER_PALLET: 'CANT / PALLET',
            EXCEL_CARRY_OVER_UPPER: 'CARRY OVER',
            EXCEL_FRESH_MANIFEST_PREFIX: 'Manifiesto fresco :',
            EXCEL_SUBTOTAL: 'SUBTOTAL',
            EXCEL_TOTAL_SOLD_UPPER: 'TOTAL VENDIDO',
            EXCEL_BALANCE_PALLETS: 'SALDO (PALLETS)',
            EXCEL_BALANCE_LOADS: 'SALDO (CARGAS)',
            EXCEL_PCT_SOLD: '% Vendido',
            EXCEL_SOLD_PCT_COL: '% VEND',
            EXCEL_PREV_WK_SHORT: 'Sem. {{week}}',
            EXCEL_VESSEL_LINE: 'Buque - Semana {{week}} {{name}}',
            EXCEL_HDR_SALESPERSON: 'VENDEDOR:',
            EXCEL_HDR_ACCOUNT: 'CUENTA:',
            EXCEL_HDR_ORDER: 'PEDIDO #',
            EXCEL_HDR_NOTES: 'NOTAS:',
            ZERO_QTY_NO_LOTS_NOTICE:
                'Con los filtros seleccionados, todos los códigos de parte muestran cantidades en cero (manifiesto, carry over, vendido y disponible) y no hay lotes en este período. Ajuste los filtros o verifique el inventario.'
        }
		},
		GENERAL: {
			RESET: 'Restablecer',
			CANCEL: 'Cancelar',
			REMOVE: 'Eliminar'
		},
		MODAL_CONFIRMATION: {
			ACCEPT: 'Aceptar',
			CANCEL: 'Cancelar',
		},
		CONTAINER_REPORT: {
			TOOLTIP_GROUP_BY_COLUMN: 'Agrupar filas de la tabla por esta columna',
			TOOLTIP_FILTER_COLUMN: 'Filtrar filas por valores de esta columna',
		},
		CNC: {
			CNC: {
				MESSAGE_REMOVE: '¿Está seguro de que desea eliminar este registro?',
				MESSAGE_SOURCE_RESET: 'Cambiar este parámetro restablecerá el formulario, ¿desea continuar? Y presentar solo el formulario vacío',
				MESSAGE_REMOVE_COMPLAINT: '¿Está seguro de que desea cancelar esta queja?',
				MESSAGE_RESET: 'Cambiar esta opción restablecerá el formulario, ¿desea continuar? Y presentar solo el formulario vacío',
				MESSAGE_ADD: 'Hay información en la tabla sin un checkbox seleccionado, que no se agregará. ¿Desea continuar?',
				MESSAGE_ROLLBACK_TODO: '¿Está seguro de que desea revertir este proceso?',
			},
			VALIDATION: {
				REQUIRED_FIELD: 'Campo requerido',
				MIN_LENGTH_FIELD: 'Longitud mínima del campo:',
				MIN_LENGTH_FIELD_DESCRIPTION: 'Por debajo de la longitud mínima de 50 caracteres.',
				MAX_LENGTH_FIELD: 'Longitud máxima del campo:',
				INVALID_DATE_RANGE: 'Rango de fechas inválido.',
				NOT_RECORDS_FOUND: 'No se encontraron registros.',
				NO_NEGATIVE_NUMBERS_QUANTITY: 'No puede ser cero o negativo',
				NO_NEGATIVE_PRICE: 'No puede ser cero o negativo',
				SUM_EXCEEDED: 'La suma excede la cantidad ordenada.',
				MAX_LENGTH_PRICE: 'Excede el precio de la orden.',
				AT_LEAST_ONE_OPTION_REQUIRED: 'Debe seleccionarse al menos una opción.',
				INVALID_EMAIL: 'El correo electrónico no es válido.',
				MINIMUM_VALUE: 'No puede ser negativo',
				GL_ACCOUNT_REQUIRED: 'El número de cuenta GL es requerido',
				GL_ACCOUNT_PATTERN: 'Debe tener exactamente 6 dígitos'
			}
		}
	}
};
